/** Maps module ids (FEATURES) to app routes for safe redirects when access is denied. */
export const MODULE_TO_PATH = {
  dashboard: '/dashboard',
  patients: '/patients',
  appointments: '/appointments',
  ipd: '/ipd',
  pharmacy: '/pharmacy',
  lab: '/lab',
  billing: '/billing',
  inventory: '/inventory',
  hr: '/hr',
  documents: '/documents',
  audit: '/audit',
  users: '/users',
  my_calendar: '/my-calendar',
  role_management: '/roles',
};

export function firstAccessibleModulePath(allowedModules) {
  if (!Array.isArray(allowedModules) || allowedModules.length === 0) {
    return '/settings';
  }
  for (const m of allowedModules) {
    const p = MODULE_TO_PATH[m];
    if (p) return p;
  }
  return '/settings';
}
